import React, { useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent } from '@mui/material'
import { useForm } from 'react-hook-form'
import { PartialShoesAction, ShoesState } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { SavedIdDisplay } from 'src/features/simulationConfirm/Components/SavedIdDisplay'
import { SavedCaution } from 'src/features/simulationConfirm/Components/SavedCaution'
import { watchFormDefaultValue } from 'src/constants'
import { UsModelCaution } from 'src/features/simulationConfirm/Components/UsModelCaution'
import { SideSurface } from 'src/Components/Domain/SideSurface'
import { useShoesCanStepFurther } from '../hooks/useShoesCanStepFurther'
import { ShoesSaveButton } from './ShoesSaveButton'
import { ShoesConsumerForm } from './ShoesConsumerForm'
import { ShoesSimulationContent } from './ShoesSimulationContent'
import { ShoesPriceArea } from './ShoesPriceArea'
import { RearSurface } from 'src/Components/Domain/RearSurface'
import { FrontSurface } from 'src/Components/Domain/FrontSurface'
import { useDrawShoesSide } from 'src/features/atoms/shoes/drawer/hooks/useDrawShoesSide'
import { useDrawShoesRear } from 'src/features/atoms/shoes/drawer/hooks/useDrawShoesRear'
import { useDrawShoesFront } from 'src/features/atoms/shoes/drawer/hooks/useDrawShoesFront'

const muiDialogSx = {
  '& .MuiDialog-paper': {
    margin: '16px'
  }
}

type Props = {
  state: ShoesState
  isDialogOpen: boolean
  handleDialogClose: () => void
  dispatch: React.Dispatch<PartialShoesAction>
}

// このコンポーネントが依存する配下のコンポーネントを全て整備する
export const ShoesSimulationConfirmDialog: React.FC<Props> = ({ state, isDialogOpen, handleDialogClose, dispatch }) => {
  const { watch, register } = useForm(watchFormDefaultValue)
  const { t } = useLocale()
  const [savedId, setSavedId] = useState<string>('')
  const [isCopied, setCopied] = useState<boolean>(false)
  const { canSave, canInputConsumer, canClose, existEmoji, setIsSave } = useShoesCanStepFurther(state, isCopied, watch)
  const handleClear = () => {
    handleDialogClose()
    setSavedId('')
    // setIsSave(false)
    setCopied(false)
  }
  const props = { state, brand: 'atoms' }
  const productNumber = state.baseModel.productNumber

  const frontSurfaceId = 'frontSurfaceConfirm'
  useDrawShoesFront(frontSurfaceId, state)
  const sideSurfaceId = 'sideSurfaceConfirm'
  useDrawShoesSide(sideSurfaceId, state)
  const rearSurfaceId = 'rearSurfaceConfirm'
  useDrawShoesRear(rearSurfaceId, state)

  return (
    <Dialog open={isDialogOpen} maxWidth={'xl'} sx={muiDialogSx}>
      <DialogContent style={{ padding: '16px 16px' }}>
        <Box display={'flex'}>
          <Box>
            <FrontSurface frontSurfaceId={frontSurfaceId} />
          </Box>
          <Box>
            <SideSurface sideSurfaceId={sideSurfaceId} />
          </Box>
          <Box>
            <RearSurface rearSurfaceId={rearSurfaceId} />
          </Box>
        </Box>
        <Box px={1} textAlign="left" color={'red'} bgcolor={'white'} fontSize={14}>
          {t.DRAWING_SHOES_CAUTION}
        </Box>
        <ShoesSimulationContent {...{ state }} />
        <ShoesPriceArea {...{ state }} />
        <ShoesConsumerForm {...{ existEmoji, dispatch, register }} isDisabled={!canInputConsumer} />
      </DialogContent>

      <DialogActions style={{ flex: 'unset', display: 'unset' }}>
        <SavedIdDisplay savedId={savedId} isCopied={isCopied} setCopied={setCopied} />
        <UsModelCaution {...{ productNumber }} />
        <Box display={'flex'} justifyContent={'space-around'}>
          <ShoesSaveButton
            {...{ ...props, setSavedId, setIsSave, frontSurfaceId, sideSurfaceId, rearSurfaceId }}
            email={watch('mailAddress')}
            disabled={false}
          />
          <Button variant="outlined" onClick={handleClear} /** disabled={!canClose} */>
            {t.CLOSE}
          </Button>
          <Button variant="contained" color="primary" href={`/checkout?id=${savedId}`} sx={{ ml: 2 }} disabled={savedId.length === 0}>
            {t.CHECKOUT}
          </Button>
        </Box>
        <SavedCaution {...{ savedId }} />
      </DialogActions>
    </Dialog>
  )
}
